import { isClient } from './isClient';

export const scrollToUtil = headerHeight => ref => {
  if (isClient) {
    window.scrollTo(0, ref?.current?.offsetTop - headerHeight);
  }
};
